import { Notification } from 'element-ui';
import router from '@/router';
import store from '@/store';
import { api } from '@/store/service';
import debounce from './debounce';

/**
 * Handler error of all async calls of seller platform
 * @param {Object} error
 */
const errorHandler = async function errorHandler(error = {}) {
  console.log('error', error);
  const { commit, dispatch } = store;
  const isForbidden = error.response && error.response.status === 403;
  const isUnauthorized = error.code === 'ECONNABORTED' || (error.response && error.response.status === 401);
  const isPaymentRequired = error.response && error.response.status === 402;

  if (isForbidden) {
    await dispatch('menu/list');
    const user = await api('get', 'profiles');
    delete user.address;
    delete user.city;
    delete user.country_code;
    delete user.middle_name;
    delete user.state;
    delete user.zip_code;
    delete user.zip_code_p2;
    commit('user/update', user);
    router.push('/home');
  } else if (isPaymentRequired) {
    commit('company/isAccountDisabled', true);
    router.push('/');
  } else if (isUnauthorized) {
    commit('menu/update', []);
    commit('auth/update', { isAuthenticated: false, access_token: null });
    commit('user/update', {
      associated_roles: [],
      companies: [],
      email: '',
      has_logged_in: false,
      first_name: '',
      last_name: '',
      role_code: '',
      role_name: '',
      scopes: [],
      hashScopes: {},
      phone_number: '',
      user_id: '',
      user_status: '',
    });

    // Check the current path. If this error happens on external surveys, don't redirect
    if (window.location.pathname.substring(0, 7) !== '/survey') {
      router.push('/login');
    }
  } else {
    let message = '';
    if (error.response
      && error.response.data
      && error.response.data.errors
      && error.response.data.errors.length > 0) {
      message = error.response.data.errors[0].detail
      || error.response.data.errors[0].title
      || '';
    }

    if (message !== '') {
      debounce(() => {
        Notification({
          type: 'error',
          title: 'Error',
          message,
        });
      }, 1000)();
    }
  }
};

export default errorHandler;
